// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1UHk-","title":"AfterFrontImage_title__1lSjx"};